module.exports = __webpack_public_path__ + "static/media/research-hero.0afc3bef.png";